/* best-sellers-carousel.js — Best Sellers Carousel logic */
(function () {
  'use strict';

  function initCarousel(S) {
    const track = S.querySelector('.bs-track');
    const cards = Array.from(S.querySelectorAll('.bs-card'));
    const dots  = Array.from(S.querySelectorAll('.bs-dot'));
    const prev  = S.querySelector('.bs-arr--p');
    const next  = S.querySelector('.bs-arr--n');

    if (!track || !cards.length) return;

    const mob    = () => window.innerWidth < 750;
    const animOn = () => mob() ? S.dataset.animM === 'true' : S.dataset.animD === 'true';
    const autoOn = () => mob() ? S.dataset.autoM === 'true' : S.dataset.autoD === 'true';
    const spd    = parseInt(S.dataset.speed, 10) || 3500;

    let cur = 0, timer = null, tx = 0;

    /* card width + gap */
    function cw() {
      return cards[0].offsetWidth + (parseFloat(getComputedStyle(track).gap) || 0);
    }

    /* scroll to index */
    function goTo(i) {
      const n = cards.length;
      cur = ((i % n) + n) % n;
      track.scrollTo({ left: cur * cw(), behavior: 'smooth' });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === cur); });
    }

    /* controls */
    if (prev) prev.addEventListener('click', function () { bump(); goTo(cur - 1); });
    if (next) next.addEventListener('click', function () { bump(); goTo(cur + 1); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { bump(); goTo(i); });
    });

    /* touch / swipe */
    track.addEventListener('touchstart', function (e) {
      tx = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var dx = tx - e.changedTouches[0].clientX;
      if (Math.abs(dx) > 48) { bump(); goTo(cur + (dx > 0 ? 1 : -1)); }
    }, { passive: true });

    /* sync dots on native scroll */
    var st;
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var w = cw();
        if (!w) return;
        cur = Math.round(track.scrollLeft / w);
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === cur); });
      }, 80);
    }, { passive: true });

    /* auto-scroll */
    function startAuto() {
      if (!autoOn() || cards.length < 2) return;
      timer = setInterval(function () { goTo(cur + 1); }, spd);
    }
    function bump() { clearInterval(timer); startAuto(); }

    S.addEventListener('mouseenter', function () { clearInterval(timer); });
    S.addEventListener('mouseleave', startAuto);

    /* entrance animations */
    if (animOn()) {
      cards.forEach(function (c) { c.classList.add('bs-card--hidden'); });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('bs-card--visible');
              io.unobserve(e.target);
            }
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
        cards.forEach(function (c) { io.observe(c); });
      } else {
        cards.forEach(function (c) { c.classList.add('bs-card--visible'); });
      }
    }

    startAuto();
  }

  document.querySelectorAll('.bs-section').forEach(initCarousel);

})();
